var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneTimeCampaign(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.49997 8.15625L14.5 0.156247C14.8125 -0.0312533 15.25 -0.0312533 15.5625 0.187497C15.875 0.406247 16.0312 0.781247 15.9687 1.15625L13.9687 14.1562C13.875 14.7812 13.1875 15.1875 12.5937 14.9375L8.71872 13.3125L6.78122 15.6562C6.59372 15.875 6.31247 16 5.99997 16C5.43747 16 4.99997 15.5625 4.99997 15V11.75L0.59372 9.9375C-0.15628 9.625 -0.21878 8.5625 0.49997 8.15625ZM2.12497 8.9375L5.96872 10.5312L5.93747 10.5L12.7812 2.84375L2.12497 8.9375ZM12.5937 13.3125L14.0625 3.65625L7.37497 11.125L12.5937 13.3125Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneTimeCampaign);
export default __webpack_public_path__ + "static/media/one-time-campaign.90786a774c3cda608bb406f663fbefd6.svg";
export { ForwardRef as ReactComponent };